"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var baseTheme = require("../../styles/baseForm.scss");
var theme = require("./theme.scss");
var containers_1 = require("../../containers");
var ui_1 = require("@vidazoo/ui");
var components_1 = require("./components");
var mobx_react_1 = require("mobx-react");
var NotificationCenter = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationCenter, _super);
    function NotificationCenter(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onSearch = function (e) {
            var userNotificationsStore = _this.props.userNotificationsStore;
            userNotificationsStore.setSearch(e.target.value);
        };
        _this.onSearchClear = function () {
            var userNotificationsStore = _this.props.userNotificationsStore;
            userNotificationsStore.clearSearch();
        };
        _this.onSelectForward = function () {
            var _a = _this.props.userNotificationsStore, onSelectItem = _a.onSelectItem, items = _a.items, selectedItemIndex = _a.selectedItemIndex;
            if (selectedItemIndex + 1 < items.length) {
                return onSelectItem(items[selectedItemIndex + 1]._id);
            }
        };
        _this.onSelectPrevious = function () {
            var _a = _this.props.userNotificationsStore, onSelectItem = _a.onSelectItem, items = _a.items, selectedItemIndex = _a.selectedItemIndex;
            if ((selectedItemIndex - 1 < items.length) && selectedItemIndex > 0) {
                return onSelectItem(items[selectedItemIndex - 1]._id);
            }
        };
        _this.onSettingsClick = function () {
            var history = _this.props.history;
            history.push("/notification-settings");
        };
        return _this;
    }
    NotificationCenter.prototype.renderLoader = function () {
        return (React.createElement("div", { className: theme.pageMessageContainer },
            React.createElement("div", { className: baseTheme.message },
                React.createElement(ui_1.Loader, { size: 1, gray: true, className: baseTheme.loader }),
                React.createElement(ui_1.PageMessage, { small: true, title: "Loading Notification Center", description: "Please wait..." }))));
    };
    NotificationCenter.prototype.renderError = function () {
        return (React.createElement("div", { className: theme.pageMessageContainer },
            React.createElement("div", { className: baseTheme.message },
                React.createElement(ui_1.PageMessage, { small: true, title: "Failed to load Notification Center", description: "We had an error loading the requested page.", iconName: "icon-rejected-status" }))));
    };
    NotificationCenter.prototype.renderEmpty = function () {
        return (React.createElement("div", { className: theme.notificationEmpty },
            React.createElement(ui_1.PageMessage, { small: true, title: "No notification selected", description: "Please select a notification to continue...", iconName: "icon-warning" })));
    };
    NotificationCenter.prototype.render = function () {
        var _a, _b;
        var userNotificationsStore = this.props.userNotificationsStore;
        var filteredItems = userNotificationsStore.filteredItems, isLoading = userNotificationsStore.isLoading, onSelectItem = userNotificationsStore.onSelectItem, selectedItem = userNotificationsStore.selectedItem, loadError = userNotificationsStore.loadError, selectedItemIndex = userNotificationsStore.selectedItemIndex, search = userNotificationsStore.search;
        return (React.createElement(ui_1.PageContainer, { pageTitle: "Notification Center", className: theme.pageContainer, style: { padding: "0" } },
            !loadError ?
                React.createElement("div", { className: theme.container }, !isLoading && filteredItems ?
                    React.createElement("div", { style: { flexDirection: "row", display: "flex" } },
                        React.createElement("div", { className: theme.itemsContainer },
                            React.createElement("div", { className: theme.inner },
                                React.createElement("div", { className: theme.settingsClass, onClick: this.onSettingsClick },
                                    React.createElement(ui_1.LinkButton, { iconName: "icon-settings", iconSize: 2.2 }),
                                    React.createElement("div", { className: theme.notificationSettings }, "Notification Settings")),
                                React.createElement("div", { className: theme.searchContainer },
                                    React.createElement(ui_1.SearchBar, { className: theme.searchBar, inner: true, placeholder: "Search", value: search, onChange: this.onSearch, onClear: this.onSearchClear })),
                                React.createElement("div", { className: theme.notifications }, filteredItems.map(function (notification) { return (React.createElement(components_1.Notification, { key: notification._id, notification: notification, onSelectItem: onSelectItem, selectedItemId: selectedItem ? selectedItem._id : null })); })))),
                        selectedItem ?
                            React.createElement("div", { className: theme.notificationMessageContainer },
                                React.createElement("div", { className: theme.topBar },
                                    React.createElement("div", { className: theme.left, onClick: this.onSettingsClick }),
                                    React.createElement("div", { className: theme.right },
                                        React.createElement("div", { className: theme.count },
                                            selectedItemIndex + 1,
                                            " / ",
                                            filteredItems.length),
                                        React.createElement("div", { className: theme.controls },
                                            React.createElement(ui_1.IconButton, { className: classnames(theme.icon, (_a = {}, _a[theme.disabled] = selectedItemIndex === 0, _a)), iconName: "icon-arrow-left-small", onClick: this.onSelectPrevious }),
                                            React.createElement(ui_1.IconButton, { className: classnames(theme.icon, (_b = {}, _b[theme.disabled] = selectedItemIndex === filteredItems.length - 1, _b)), iconName: "icon-arrow-right-small", onClick: this.onSelectForward })))),
                                React.createElement(components_1.NotificationMessage, { selectedItem: selectedItem }))
                            : this.renderEmpty())
                    : null)
                : null,
            isLoading ? this.renderLoader() : null,
            loadError ? this.renderError() : null));
    };
    NotificationCenter.defaultProps = {};
    NotificationCenter = tslib_1.__decorate([
        mobx_react_1.observer
    ], NotificationCenter);
    return NotificationCenter;
}(containers_1.BaseContainer));
exports.default = NotificationCenter;
